var React = require('react');

function Icon5Inline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#ef7800","d":"M39.93 14.793H10.344V9.862H39.93zm-9.862 14.793H10.344v-4.931h19.724zM10.344 17.258H39.93v4.931H10.344zM44.861 0H5.413C2.701 0 .507 2.219.507 4.931L.482 49.31l9.862-9.862h34.517a4.945 4.945 0 0 0 4.931-4.931V4.93A4.945 4.945 0 0 0 44.862 0z"}))));
}

Icon5Inline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Icon5Inline;

Icon5Inline.default = Icon5Inline;
